var sensitivity = 1;
var sensitivityVertical = 5;
